import { Input, Icon, Popup, Menu, Button, Flex } from 'nallian-shared-ui/lib/components';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// the NoBreakSpan wrapping component is necessary otherwise the popup will not show at the correct location.
const NoBreakSpan = styled.span`
  white-space: nowrap;
`;

const FieldFlex = styled(Flex)`
  && .ui.fluid.input > input {
    width: 190px !important;
    margin-right: 15px;
  }
`;

const AddBlobLanguage = ({ callback, header, footer }) => {
  const { t } = useTranslation();

  const [language, setLanguage] = useState('');
  const handleCallback = useCallback(() => {
    callback(undefined, { name: language, isNew: true, header, footer });
    setLanguage('');
  }, [setLanguage, language, callback, header, footer]);

  const handleSetLanguage = useCallback((_, { value }) => setLanguage(value), [setLanguage]);

  return (
    <Popup
      position="right center"
      on="hover"
      flowing
      hoverable
      trigger={
        <NoBreakSpan>
          <Menu.Item name="new" key="new" content={<Icon name="plus" />} />
        </NoBreakSpan>
      }
    >
      <FieldFlex>
        <Input
          fluid
          name="language"
          placeholder={t('enterLanguageKey')}
          value={language}
          onChange={handleSetLanguage}
        />
        <Button btnprimary content={t('addLanguage')} onClick={handleCallback} />
      </FieldFlex>
    </Popup>
  );
};

AddBlobLanguage.propTypes = {
  callback: PropTypes.func.isRequired,
  header: PropTypes.bool,
  footer: PropTypes.bool,
};

AddBlobLanguage.defaultProps = {
  header: false,
  footer: false,
};

export default AddBlobLanguage;
